import { render, staticRenderFns } from "./autoIndex.vue?vue&type=template&id=180c9bc2&scoped=true"
import script from "./autoIndex.vue?vue&type=script&lang=js"
export * from "./autoIndex.vue?vue&type=script&lang=js"
import style0 from "./autoIndex.vue?vue&type=style&index=0&id=180c9bc2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "180c9bc2",
  null
  
)

export default component.exports